import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import Config from "../../../core/config/Config";
import AbstractMediator from "../../../core/ui/AbstractMediator";

export default class EndScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {RevisableLanguagePack} languagePack 
     * @param {Config} config 
     */
    constructor(target, dispatcher, languagePack, config) {
        super(target, dispatcher);

        this._languagePack = languagePack;
        this._config = config;
    }

    initialize() {
        super.initialize();

        this._target.titleTextField.text = this._languagePack.getText('endOfSim.title');
        this._target.bodyTextField.text = this._languagePack.getText('endOfSim.body');
        this._target.websiteInformationTextField.text = this._languagePack.getText('endOfSim.websitePrefix');
        this._target.acknowledgementTextField.text = this._languagePack.getText('endOfSim.acknowledgement');
        
        this.createButton(this._target.surveyButton, this._handleSurveyButton.bind(this), this._languagePack.getText('endOfSim.surveyButtonLabel'));
        this.createButton(this._target.readyWebsiteButton, this._handleReadyWebsiteButton.bind(this), this._languagePack.getText('endOfSim.websiteButtonLabel'));
    }

    _handleSurveyButton() {
        const surveyLink = this._config.getValue('externalResources.surveyLink');
        window.open(surveyLink,'_blank');
    }

    _handleReadyWebsiteButton() {
        const websiteLink = this._config.getValue('externalResources.websiteLink');
        window.open(websiteLink,'_blank');
    }
}